import {
   DRIVING_LICENSE_DURATION_OPTIONS,
   TAXI_INSURANCE_COVERAGE_TYPE_OPTIONS,
   TAXI_MAX_PASSENGER_OPTIONS,
   TAXI_VEHICLE_TYPE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import {ValidateStep5Data} from "@validators/taxi-insurance-form/step5-validator";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import {TermsAgreementBlock} from "@components/common/form-blocks/other/terms-agreement-block";

export default function IF_Step5(
    {
        data,
        handlers,
        setCurrentStep,
        onSubmit,

    }) {

    const STEP = 5;

    const onPrevBtnClick = (event) => {
        setCurrentStep(STEP - 1);
    }

    const onNextBtnClick = (event) => {

        let validationResult = ValidateStep5Data(data);

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult : validationResult
            });


        } else {
            onSubmit();
        }


    }

    return (
        <div className={`if-step-${STEP}`}>


            <SectionHeading
                text="Your Taxi"
            />


            {/* What type of vehicle is it? */}

            <ScrollableDropdownBlock
                controlName="taxiVehicleType"
                containerCssClass="col-12 py-3"
                labelText="What type of vehicle is it?"
                required={true}
                options={TAXI_VEHICLE_TYPE_OPTIONS}
                selectedValues={data.taxiVehicleType}
                onChange={handlers.onControlChange}
                helpText=""
            />




            {/* Roughly, how much is the taxi worth? */}


            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3"
                labelText="Roughly, how much is the taxi worth?"
                required={false}
                controlName="taxiWorth"
                value={data.taxiWorth}
                onChange={handlers.onControlChange}
                inputAttrs={{"type": "number", "maxLength": 10}}
                asTextArea={false}
            />

            {/* Which council did issue your taxi licence? */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Which council did issue your taxi licence?"
                required={true}
                controlName="taxiLicenseIssuerCouncil"
                value={data.taxiLicenseIssuerCouncil}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 50
                }}
            />


            {/* On which date did you get your taxi badge? */}

            <ScrollableCustomDateTimePickerBlock
                containerCssClass="col-12 py-3 "
                labelText="On which date did you get your taxi badge?"
                required={true}
                controlName="taxiBadgeDate"
                value={data.taxiBadgeDate}
                onChange={handlers.onControlChange}
            />

            {/* What is the maximum number of passengers? */}

            <ScrollableDropdownBlock
                controlName="taxiMaxPassengers"
                containerCssClass="col-12 py-3"
                labelText="How many passengers can you carry?"
                required={true}
                options={TAXI_MAX_PASSENGER_OPTIONS}
                selectedValues={data.taxiMaxPassengers}
                onChange={handlers.onControlChange}
                helpText=""
            />

            {/* Are you enrolled with any local taxi company? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="Are you enrolled with any local taxi company?"
                required={true}
                controlName="isEnrolledWithLocalTaxiCompany"
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={data.isEnrolledWithLocalTaxiCompany}
                onChange={handlers.onControlChange}
            />

            {data.isEnrolledWithLocalTaxiCompany === 'Yes' && (

                <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Name of the local taxi company"
                required={true}
                controlName="localTaxiCompanyName"
                value={data.localTaxiCompanyName}
                onChange={handlers.onControlChange}
                inputAttrs={{
                maxLength: 50
            }}
                />

            )}

            {/* Do you accept cash or card payment? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="Do you accept cash or card payment?"
                required={true}
                controlName="doesAcceptCashOrCardPayment"
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={data.doesAcceptCashOrCardPayment}
                onChange={handlers.onControlChange}
            />

            <SectionHeading
                text="Cover"
            />


            {/* What type of cover would you like? */}

            <ScrollableDropdownBlock
                controlName="taxiCoverageType"
                containerCssClass="col-12 py-3"
                labelText="What type of cover would you like?"
                required={true}
                options={TAXI_INSURANCE_COVERAGE_TYPE_OPTIONS}
                selectedValues={data.taxiCoverageType}
                onChange={handlers.onControlChange}
                helpText=""
            />


            {/* How many years have you held your licence? */}

            <ScrollableDropdownBlock
                controlName="taxiLicenseDuration"
                containerCssClass="col-12 py-3"
                labelText="How many years have you held your licence?"
                required={false}
                options={DRIVING_LICENSE_DURATION_OPTIONS}
                selectedValues={data.taxiLicenseDuration}
                onChange={handlers.onControlChange}
                helpText=""
            />


            {/* How long have you held your taxi badge? */}


            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3"
                labelText="How long have you held your taxi badge?"
                required={false}
                controlName="taxiBadgeDuration"
                value={data.taxiBadgeDuration}
                onChange={handlers.onControlChange}
                inputAttrs={{"type": "number", "maxLength": 10}}
                asTextArea={false}
            />


            {/* Where was your taxi badge obtained? */}


            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3"
                labelText="Where was your taxi badge obtained?"
                required={false}
                controlName="taxiBadgeObtainedAt"
                value={data.taxiBadgeObtainedAt}
                onChange={handlers.onControlChange}
                inputAttrs={{"maxLength": 50}}
                asTextArea={false}
            />


            {/* Who will be driving the taxi? */}


            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3"
                labelText="Who will be driving the taxi?"
                required={false}
                controlName="taxiDriver"
                value={data.taxiDriver}
                onChange={handlers.onControlChange}
                inputAttrs={{"maxLength": 50}}
                asTextArea={false}
            />


            {/* How do you mainly use the taxi? */}


            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3"
                labelText="How do you mainly use the taxi?"
                required={false}
                controlName="taxiMainUsages"
                value={data.taxiMainUsages}
                onChange={handlers.onControlChange}
                inputAttrs={{"maxLength": 50}}
                asTextArea={false}
            />


            {/* How many years of taxi no claims discount do you have? */}


            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3"
                labelText="How many years of taxi no claims discount do you have?"
                required={false}
                controlName="taxiNoClaimDiscountYears"
                value={data.taxiNoClaimDiscountYears}
                onChange={handlers.onControlChange}
                inputAttrs={{"type": "number", "maxLength": 50}}
                asTextArea={false}
            />


            {/* How many years of private car no claims discount do you have? */}


            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3"
                labelText="How many years of private car no claims discount do you have?"
                required={false}
                controlName="privateCarNoClaimDiscountYears"
                value={data.privateCarNoClaimDiscountYears}
                onChange={handlers.onControlChange}
                inputAttrs={{"maxLength": 50}}
                asTextArea={false}
            />


            {/* Have you made any claims in the last 5 years? */}

           {/* <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3"
                labelText="Have you made any claims in the last 5 years?"
                required={false}
                controlName="hadMadeAnyClaimsInLast5Year"
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={data.hadMadeAnyClaimsInLast5Year}
                onChange={handlers.onControlChange}
            />*/}


            {/* Have you had any motoring convictions in the last 5 years? */}

            {/*<ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3"
                labelText="Have you had any motoring convictions in the last 5 years?"
                required={false}
                controlName="hadMotoringConvictionsInLast5Years"
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={data.hadMotoringConvictionsInLast5Years}
                onChange={handlers.onControlChange}
            />*/}
           
           


            {/* Are you an Uber driver? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3"
                labelText="Are you an Uber driver?"
                required={true}
                controlName="isAnUberDriver"
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={data.isAnUberDriver}
                onChange={handlers.onControlChange}
            />


            {/* Additional comments */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Additional comments"
                required={false}
                controlName="addAdditionalComments"
                value={data.addAdditionalComments}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 1024,
                    rows: 5
                }}
                asTextArea={true}
            />

           
           <TermsAgreementBlock
              selectedValue={data.termsAgreement}
              controlIdPrefix={`termsAgreement-`}
              controlName={`termsAgreement`}
              onChange={handlers.onControlChange}
              required={true}
           />
           
           <WizardStepButtonsBlock
              onPrevBtnClick={onPrevBtnClick}
              onNextBtnClick={onNextBtnClick}
              nextBtnIconClass={`fa fa-save me-2`}
              nextBtnIconPosition={`left`}
              nextBtnText={`Submit`}
              isNextBtnDisabled={data.termsAgreement !== 'Yes'}
              nextButtonAdditionalCssClass={``}
           />


        </div>
    );
}